// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1Pqql","content":"styles_content__3utFp","text":"styles_text__1qs9N","image":"styles_image__1GgRw"};